import classNames from "components/ui/classNames";

interface ValueColumnProps {
  label: string;
  value: string;
  className?: string;
}
export default function ValueColumn({ label, value, className }: ValueColumnProps) {
  return (
    <div className="flex flex-col">
      <h1 className={classNames("text-xl font-bold text-slate-600 dark:text-slate-100", className)}>{value}</h1>
      <p className="text-xs font-medium text-gray-500 dark:text-slate-400">{label}</p>
    </div>
  );
}
